<div
  *ngIf="data"
  class="profile"
  fxLayout="row"
  fxLayoutAlign="center center" (click)="getSingleLog()">
  <div class="tag" fxLayout="row" fxLayoutAlign="start center">
    <span>View</span>
  </div>
</div>
